import { useFormatMessage } from 'helpers/intl'
import { uniqueUserSVG } from '../../../../assets/svg/user'
import { TransactionMetric } from '../../../../models/analytics'
import { capitalizeFirstLetter } from 'helpers/users'
import { CoreInfoCard } from 'components/cards'

interface props {
  metrics?: TransactionMetric
  loading: boolean
}

const TotalUniqueUsers = ({ metrics, loading }: props) => {
  const uniqueUsersTitle = useFormatMessage('dashboard.transactionsPage.statsView.uniqueUsers', 'Unique Users')

  return (
    <CoreInfoCard
      title={capitalizeFirstLetter(uniqueUsersTitle)}
      wsLoading={loading}
      overviewIcon={uniqueUserSVG}
      infoText={(metrics?.uniqueUsers || 0).toLocaleString()}
    />
  )
}

export default TotalUniqueUsers
